$(document).on('submit', '.ajax-form', function (event) {
    event.preventDefault();
});

$(document).on('beforeSubmit', '.ajax-form', function () {
    let that = this,
        formData = new FormData(that);

    $.ajax({
        'cache': false,
        'type': 'POST',
        'dataType': 'json',
        'data': formData,
        'processData': false,
        'contentType': false,
        'success': function (response) {
            parseResponse(response);
        },
        'url': that.action
    });
});

export function parseResponse(response) {
    if (response.replaces instanceof Array) {
        for (var i = 0, ilen = response.replaces.length; i < ilen; i++) {
            $(response.replaces[i].what).replaceWith(response.replaces[i].data);
        }
    }
    if (response.append instanceof Array) {
        for (i = 0, ilen = response.append.length; i < ilen; i++) {
            $(response.append[i].what).append(response.append[i].data);
        }
    }
    if (response.prepend instanceof Array) {
        for (i = 0, ilen = response.prepend.length; i < ilen; i++) {
            $(response.prepend[i].what).prepend(response.prepend[i].data);
        }
    }
    if (response.content instanceof Array) {
        for (i = 0, ilen = response.content.length; i < ilen; i++) {
            $(response.content[i].what).html(response.content[i].data);
        }
    }

    if (response.js) {
        $("body").append(response.js);
    }
    if (response.refresh) {
        window.location.reload(true);
    }
    if (response.redirect) {
        window.location.href = response.redirect;
    }
}